var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"list-order",class:_vm.orderClass,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }